export default {
  API: {
      ENDPOINT: 'https://sourcing_api.korodrogerie.de/'
  }
};
